<template>
  <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
      </div>
    </div>
    <div style="margin-top: -5%;" v-if="loaderStatus">
                                    <loader></loader>
                                </div>
    <div class="table-responsive" v-else>
      <vue-good-table
              :columns="columns"
              :rows=pendingLoans
              :line-numbers="true"
              :search-options="{
                        enabled: true,
                        }"
              :sort-options="{
                        enabled: true,
                        initialSortBy: {field: 'application_date', type: 'desc'}}"
              :pagination-options="{
                enabled: true,
                perPage: 5
                }"
              styleClass="table table-striped table-no-bordered table-hover">
        <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
            <base-button type="primary" size="sm" @click="viewSummary(props.row)">View</base-button>
            <base-button type="danger" size="sm" @click="accept(props.row)">Accept</base-button>
            <base-button type="warning" size="sm" @click="reject(props.row)">Reject</base-button>
    </span>
          <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
        </template>
      </vue-good-table>
    </div>
  </div>
   </base-header>
    </div>
</template>
<script>
import Swal from 'sweetalert2'
import Loader from "../../components/Loader"
  export default {
    name: 'LoanApplications',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
            Loader
        },
    data() {
      return {
        response: '',
        reject_reason: 'None',
        columns: [
          {
            label: 'Loan Applicant',
            field: 'member_name',
          },
          {
            label: 'Application Date',
            field: 'application_date',
            formatFn: this.formatDate,
          },
          {
            label: 'Amount Borrowed',
            field: 'loan_amount_figures',
            formatFn: this.formatCost,
          },
          {
            label: 'Risk Class',
            field: 'risk_class',
          },
          {
            label: '',
            field: 'action',
          },
        ],
      }
    },
    created() {
      this.authorizedUser(this.authorizeAdminOnly);
      this.$store.dispatch('viewpendingLoans_function');
    },
    methods: {
      viewSummary(params) {
        this.$router.push({
          path: 'loanSummary',
          query: {
            loanId: params.loan_application_public_id,
          },
        });
      },
      async reject(params){
        const { value: reason } = await Swal.fire({
          title: 'Enter your reject reason',
          input: 'text',
          inputPlaceholder: 'Enter your reason',
          showCancelButton: true,
        })
        if (reason) {
          this.response = "Rejected"
          this.reject_reason = reason
          const data = {
            loan_status: this.response,
            reject_reason: this.reject_reason,
            public_id : params.loan_application_public_id
          }
          console.log(data)
          this.$store.dispatch('makeLoanDecision_function', data)
        }
      },
      accept(params){
        Swal.fire({
        title: 'Are you sure?',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Accept it!'
      }).then((result) => {
        if (result.value) {
          this.response = "Accepted"
          const data = {
            loan_status: this.response,
            reject_reason: this.reject_reason,
            public_id : params.loan_application_public_id
          }
          console.log(data)
          this.$store.dispatch('makeLoanDecision_function', data)
        }
      })
      },
      formatCost(amount) {
        const result = Number(amount).toLocaleString()
        if (result !== 0) {
          return `Ksh. ${result}`;
        } else {
          return '0';
        }
      },
    },
  }
</script>
<style>
</style>
